import styled from 'styled-components';
import { ReactComponent as InfoIcon } from '@elementary/common-ui/assets/info-icon.svg';
import { Flex, FlexColumn } from '@elementary/common-ui/components';
import { pluralizeString } from '@elementary/common-ui/utils/common';
import { Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import BulkEditTable from '../BulkEditTable';
import { BulkEditFormData } from '../types';
import { getModifiedTableData } from '../utils';

const Wrapper = styled(FlexColumn)`
  padding: 24px;
  height: 100%;
  gap: 24px;
`;

const ReviewSubmitStep = () => {
  const { watch } = useFormContext<BulkEditFormData>();
  const { tableData, initialTableData, editProperty, editPropertyType } =
    watch();

  const modifiedTableData = getModifiedTableData(
    initialTableData,
    tableData,
    editProperty,
    editPropertyType,
  );

  return (
    <Wrapper>
      <FlexColumn sx={{ gap: 1 }}>
        <Typography variant="h3">
          {pluralizeString(
            modifiedTableData.length,
            'Change was',
            'Changes were',
          )}{' '}
          made
        </Typography>
        <Flex sx={{ alignItems: 'center', gap: 1 }}>
          <Flex>
            <InfoIcon />
          </Flex>
          <Typography sx={{ color: 'common.gray2' }}>
            These assets can only be edited in code. The following changes will
            be applied upon PR approval
          </Typography>
        </Flex>
      </FlexColumn>
      <BulkEditTable readOnly showOnlyModified />
    </Wrapper>
  );
};

export default ReviewSubmitStep;
